module.exports = __webpack_public_path__ + "assets/9d1b119c5cfd029d602b23b4875b4406.svg";